const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export async function minimalRetry<T>(
  fn: (args: { attempt: number; isFinalAttempt: boolean }) => Promise<T> | T,
  {
    attempts,
    interval,
    onError,
  }: { attempts: number; interval: number; onError?: (err: unknown) => void },
): Promise<T> {
  let currentTry = 0;
  let latestError: unknown;

  while (currentTry < attempts) {
    try {
      currentTry += 1;

      const result = await fn({
        attempt: currentTry,
        isFinalAttempt: currentTry === attempts,
      });

      return result;
    } catch (error) {
      onError?.({ error, currentTry });
      latestError = error;

      if (currentTry < attempts) {
        await wait(interval);
      }
    }
  }

  throw latestError || new Error(`Invalid attempts: ${attempts}`);
}
